<template>
  <!-- Begin Page Content -->
  <div class="container-fluid">

    <div class="card my-4">
      <div class="card-header row m-0">
        <div class="col">
          <h4>Дэлгүүрүүд</h4>
        </div>
        

      </div>
      <div class="card-body">

        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" id="pills-home-tab" data-toggle="pill" href="#pills-home" role="tab" aria-controls="pills-home" aria-selected="true">Байгууллага</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" id="pills-profile-tab" data-toggle="pill" href="#pills-profile" role="tab" aria-controls="pills-profile" aria-selected="false">Хувь хүн</a>
          </li>

        </ul>
        <div class="tab-content" id="pills-tabContent">
          <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
            <div class="table-responsive">
              <table
                class="table table-bordered"
                id="dataTable"
                width="100%"
                cellspacing="0"
                v-if="stores!=null && stores.length>0"
              >
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Зураг</th>
                    <th>Нэр</th>
                    <th>Дэлгэрэнгүй</th>
                    <th>Дансны үлдэгдэл</th>
                    <th>Төлөв</th>
                    <th>Үйлдэл</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(store, index) in stores">
                    <td>{{index+1}}</td>
                    <td>
                      <img
                        :src="_getImage(store)"
                        style="border: 1px solid #ddd; border-radius: 4px; padding: 5px; width: 50px;"
                      />
                    </td>
                    <td>{{store.name}}
                      <!-- {{store.id}} -->
                    </td>
                    <td>{{store.description}}</td>
                    <td>
                      <span v-if="store.balance!=null">{{store.balance}}</span>
                      <span v-else>0</span>
                    </td>
                    <td>
                      <h6 v-if="store.verified!=true"><span class="badge badge-pill badge-danger">баталгаажаагүй</span></h6>
                      <h6 v-else><span class="badge badge-pill badge-success">баталгаажсан</span></h6>
                    </td>
                    <td>
                      <div class="row">
                        <button v-if="store.verified!=true" class="btn btn-success btn-sm mx-1" @click="verifyStore(store, index)">Баталгаажуулах</button>
                        <button v-else class="btn btn-danger btn-sm mx-1" @click="verifyStore(store, index)">эрх хаах</button>
                        <button class="btn btn-info btn-sm mx-1" @click="showAccountDialog(store)">данс цэнэглэх</button>
                
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="alert alert-info text-center">Мэдээлэл оруулаагүй байна.</div>
              <button v-if="end==false" class="btn btn-block btn-success" @click="getItems()">Дараагийнх</button>
            </div>
           

          </div>
          <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
            <table
                class="table table-bordered"
                id="dataTable"
                width="100%"
                cellspacing="0"
                v-if="stores1!=null && stores1.length>0"
              >
                <thead>
                  <tr>
                    <th>№</th>
                    <th>Нэр</th>
                    <th>Дэлгэрэнгүй</th>
                    <th>Дансны үлдэгдэл</th>
                    <th>Төлөв</th>
                    <th>Үйлдэл</th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(store, index) in stores1" >
                    <td>{{index+1}}</td>
        
                    <td>{{store.name}}</td>
                    <td>{{store.description}}</td>
                    <td> 
                      <span v-if="store.balance!=null">{{store.balance}}</span>
                      <span v-else>0</span>
                    </td>
                    <td>
                      <h6 v-if="store.verified!=true"><span class="badge badge-pill badge-danger">баталгаажаагүй</span></h6>
                      <h6 v-else><span class="badge badge-pill badge-success">баталгаажсан</span></h6>
                    </td>
                    <td>
                      <div class="row">
                        <!-- <button v-if="store.verified!=true" class="btn btn-success btn-sm mx-1" @click="verifyStore(store, index)">Баталгаажуулах</button>
                        <button v-else class="btn btn-danger btn-sm mx-1" @click="verifyStore(store, index)">эрх хаах</button> -->
                        <button class="btn btn-info btn-sm mx-1" @click="showAccountDialog(store)">данс цэнэглэх</button>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div v-else class="alert alert-info text-center">Мэдээлэл оруулаагүй байна.</div>
              <button v-if="end1==false" class="btn btn-block btn-success" @click="getItems1()">Дараагийнх</button>
            </div>
           
          </div>

        </div>


    </div>

     <!-- Modal -->
    <div
      class="modal fade"
      id="accountModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="accountModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content" v-if="selectedStore">
          <div class="modal-header">
            <h5 class="modal-title" id="alertModalLabel">Данс цэнэглэх</h5>
            <br/>
            <h5>{{selectedStore.name}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <label>Нэр</label>
                <input
                  v-model.trim="selectedStore.name"
                  class="form-control"
                  placeholder="Гарчиг оруулна уу"
                  readonly
                />
              </div>

              <div class="form-group">
                <label>Дэлгэрэнгүй</label>
                <textarea
                  rows="5"
                  v-model.trim="selectedStore.description"
                  class="form-control"
                  placeholder="Тайлбар мэдээлэлээ оруулна уу"
                  readonly
                />
              </div>
              <div class="form-group">
                <label>Цэнэглэх дүн</label>
                <input
                  v-model.number="chargeValue"
                  class="form-control"
                  type="number"
                />
              </div>
              
              <hr />
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
            <button
              @click="charge(selectedStore, chargeValue)"
              type="button"
              class="btn btn-primary btn-user btn-block"
            >Цэнэглэх</button>
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- /.container-fluid -->
</template>

<script>
const fb = require("../../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../../firebaseConfig.js";
import moment from "moment";
export default {
  name: "Stores",
  data() {
    return {
      msg: "Stores",
      stores: [],
      end: false,
      lastVisible:null,
      firstVisible:null,
      loading:false,
      pageSize: 20,

      stores1: [],
      end1: false,
      lastVisible1:null,
      firstVisible1:null,
      loading1:false,
      
      selectedStore:null,
      chargeValue:0

    };
  },
  computed: {
    ...mapState(["currentUser"])
  },
  created() {
    this.getItems();
    this.getItems1();
  },
  methods: {
    _getImage(obj) {
      if (obj.images != null && obj.images != undefined) {
        return obj.images[0]["fileUrl"];
      }
    },
    async getItems(){
      if(this.end!=true){
        var querySnapshot;
        var first=false;
        if(this.lastVisible==null){
          querySnapshot=await fb.db.collection("stores").where("isOrganization", "==", true).orderBy("createdAt", "desc")
          .limit(this.pageSize)
          .get();
          if(querySnapshot!=null && !querySnapshot.empty){
            this.firstVisible=querySnapshot.docs[0];
            first=true;
          }
        }
        else{
          querySnapshot=await fb.db.collection("stores").where("isOrganization", "==", true).orderBy("createdAt", "desc").startAfter(this.lastVisible)
          .limit(this.pageSize)
          .get();
        }
        
        if(querySnapshot!=null && !querySnapshot.empty){

          if(first==true || ( first!=null && this.firstVisible.id!=null && this.firstVisible.id!=querySnapshot.docs[0].id)){
            console.log("abc");
            for(const itemDoc of querySnapshot.docs){
              let item=itemDoc.data();
              item.id=itemDoc.id;
              if(item.balance==undefined)
                item.balance=0;
              this.stores.push(item);
            }
            this.lastVisible=querySnapshot.docs[querySnapshot.docs.length-1];
          }
          else
            this.end=true;
          
        }
      }
    },
    async getItems1(){
      if(this.end1!=true){
        var querySnapshot;
        var first=false;
        if(this.lastVisible1==null){
          querySnapshot=await fb.db.collection("stores").where("isOrganization", "==", false).orderBy("createdAt", "desc")
          .limit(this.pageSize)
          .get();
          if(querySnapshot!=null && !querySnapshot.empty){
            this.firstVisible1=querySnapshot.docs[0];
            first=true;
          }
        }
        else{
          querySnapshot=await fb.db.collection("stores").where("isOrganization", "==", false).orderBy("createdAt", "desc").startAfter(this.lastVisible1)
          .limit(this.pageSize)
          .get();
        }
        if(querySnapshot!=null && !querySnapshot.empty){
          if(first==true || ( this.firstVisible1!=null && this.firstVisible1.id!=null && this.firstVisible1.id!=querySnapshot.docs[0].id)){
            for(const itemDoc of querySnapshot.docs){
              let item=itemDoc.data();
              item.id=itemDoc.id;
              if(item.balance==undefined)
                item.balance=0;
              this.stores1.push(item);
            }
            this.lastVisible1=querySnapshot.docs[querySnapshot.docs.length-1];
          }
          else
            this.end1=true;
          
        }
      }
    },
    verifyStore(store, index){
      if(store!=null && store.verified!=true && store.isOrganization==true){
        fb.db.collection("stores").doc(store.id).update({"verified": true});
        store.verified=true;
        alert("Дэлгүүр амжилттай баталгаажлаа.");
      }
      else if(store!=null && store.verified==true && store.isOrganization==true){
        fb.db.collection("stores").doc(store.id).update({"verified": false});
        store.verified=false;
        alert("Амжилттай.");
      }
    },
    showAccountDialog(store){
      this.chargeValue=0;
      this.selectedStore = store;
      $("#accountModal").modal("toggle");
    },
    charge(store, value){
      if(store!=null && store!=undefined){
        if(value!=null && value!=undefined && value>0){

          var batch = fb.db.batch();
          var storeRef = fb.db.collection("stores").doc(store.id);
          batch.update(storeRef, {"balance": fb.firestore.FieldValue.increment(value), "alertCount":fb.firestore.FieldValue.increment(1)});
          batch.set(
            storeRef.collection("alerts").doc(),
            {
              "title": "Дансанд мөнгө байршуулагдсан.",
              "description":"Таны данс "+ value+" төгрөгөөр цэнэглэгдлээ.",
              "createdAt": new Date(),
              "user": fb.db.collection('users').doc(this.currentUser.uid),
              "alertType":"AccountCharged",
              "seen":false
            }   
          );
  
           batch.set(
            storeRef.collection("accountHistory").doc(),
            {
              "title": "Дансанд мөнгө байршуулагдсан.",
              "description":"Таны данс "+ value+" төгрөгөөр цэнэглэгдлээ.",
              "createdAt": new Date(),
              "user": fb.db.collection('users').doc(this.currentUser.uid),
              "alertType":"AccountCharged",
              "success": true,  
              "value": value
            }   
          );
          batch.commit().then( () =>{
            
            $("#accountModal").modal("toggle");
            this.chargeValue=0;
            this.selectedStore=null;
            if(store.balance!=null && store.balance!=undefined){
              store.balance=store.balance+value;
            }
            else
              store.balance=value;
            alert("Амжилттай цэнэглэгдлээ.");
          });
        }
        else{
          alert("Та цэнэглэх дүнгээ оруулна уу");
        }
      }
    }
   
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    }
  }
};
</script>